module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Weather/Snow#3-8d71c9986594385d4176ad4917cdf502.svg";